import { RouteType } from './types'

/**
 * Detects the route type based on the current path
 * @param {string} path - Current URL path
 * @returns {string|null} RouteType value or null
 */
const detectRouteType = path => {
  if (path.includes('/partner-programs/')) return RouteType.PARTNER_PROGRAM

  if (path.includes('/reports/assets/') || path.includes('/asset-management/'))
    return RouteType.ASSET_CONTENT

  if (path.includes('/reports/customers/') || path.includes('/customers/customers/'))
    return RouteType.CUSTOMER

  if (path.includes('/reports/sales-reps/') || path.includes('/user-management/'))
    return RouteType.USER

  if (path.includes('/logistic-centers/')) return RouteType.LOGISTIC_CENTER
  if (path.includes('/orders/') && !path.includes('/mass-orders')) return RouteType.ORDER
  if (path.includes('/brands/')) return RouteType.BRAND
  if (path.includes('/brandlines/')) return RouteType.BRAND_LINE
  if (path.includes('/countries/')) return RouteType.COUNTRY
  if (path.includes('/inquiries/')) return RouteType.INQUIRY

  // Nested customer routes
  if (path.includes('/customers/') && path.match(/\/customers\/[a-zA-Z0-9-]+\/.+/))
    return RouteType.CUSTOMER_NESTED

  return null
}

/**
 * Hook to detect route type from current path
 * @param {string} path - Current URL path
 * @returns {string|null} RouteType value or null
 */
export const useDetectRouteType = path => detectRouteType(path)

export default detectRouteType
